export const SET_VDP_USED = 'SET_VDP_USED';

export const ADD_VEHICLES = 'ADD_VEHICLES';
export const SET_VEHICLES = 'SET_VEHICLES';

export const INVALID_STATE = 'INVALID_STATE';
